<div class="property-header">
    <div *ngIf="icon" class="property-icon"><i class="icon {{icon}}">{{icon}}</i></div>
    <div *ngIf="name" class="property-name">{{name}}</div>
    <app-tooltip *ngIf="tooltip" [content]="tooltip"></app-tooltip>
</div>
<div class="property-content">
    <ng-content></ng-content>
</div>
